export const slugify = (str) =>
  str
    ? String(str)
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '')
    : '';

export const generateHolidaySlug = (pkg) => {
  if (!pkg) return '';
  const title = slugify(pkg.package_name || pkg.name || pkg._generic_title);
  const city = slugify(pkg.city);
  const price = Math.round(pkg.offer_price || pkg.package_price || pkg.price || 0);
  const id = pkg.id;
  const parts = [title, city, price ? price : null, id].filter(Boolean);
  return parts.join('-').replace(/--+/g, '-');
};

export const generateHotelSlug = (hotel) => {
  if (!hotel) return '';
  const name = slugify(hotel.hotel_name || hotel.name || hotel._generic_title);
  const city = slugify(hotel.city || hotel.location_city);
  const price = Math.round(hotel.offer_price || hotel.hotel_price || hotel.price || 0);
  const id = hotel.id;
  const parts = [name, city, price ? price : null, id].filter(Boolean);
  return parts.join('-').replace(/--+/g, '-');
};

export const generateYatraSlug = (yatra) => {
  if (!yatra) return '';
  const title = slugify(yatra.title || yatra.name || yatra.yatra_name || yatra._generic_title);
  const city = slugify(yatra.city);
  const price = Math.round(yatra.offer_price || yatra.price || yatra.package_price || 0);
  const id = yatra.id;
  const parts = [title, city, price ? price : null, id].filter(Boolean);
  return parts.join('-').replace(/--+/g, '-');
};

export const generateMedicalSlug = (item) => {
  if (!item) return '';
  const name = slugify(item.doctor_name || item.hospital_name || item.name || item._generic_title);
  const city = slugify(item.city);
  const id = item.id;
  const parts = [name, city, id].filter(Boolean);
  return parts.join('-').replace(/--+/g, '-');
};
